<template>
    <app-dropdown
        :required="false"
        :options="mappedElectricboxes"
        :value="activeElectricalBox"
        @change="handleInput"></app-dropdown>
</template>

<script>
  import {mapState} from 'vuex';
  import Dropdown from "../../input/Dropdown";

  export default {
    name: 'ElectricBoxDropdown',

    components: {
      'app-dropdown': Dropdown
    },

    computed: {
      ...mapState({
        activeElectricalBox: state => state.build.electricalBox,
        electricBoxes: state => state.electricalBoxes.all,
      }),
      mappedElectricboxes() {
        return this.electricBoxes.map(box => {
          return {
            key: box.id,
            value: this.translate(box.name),
          }
        })
      }
    },
    //   activeElectricBox: {
    //     get() {
    //       return this.electricalBoxIndex;
    //     },
    //     set(val) {
    //       this.$store.dispatch('build/selectElectricalBox', val)
    //     }
    //   }
    // },
    methods: {
      handleInput(id) {
        this.$store.commit('build/setElectricalBox', id);
      }
    },
  }
</script>
